import { DOCUMENTS_HUB_ENABLED, HR_HUB_ENABLED } from '@/config/featureFlags';

export { DOCUMENTS_HUB_ENABLED, HR_HUB_ENABLED };

export const MAINTENANCE_HUB_IDS = ['business', 'dipendenze', 'documenti', 'applicativi', 'hr'] as const;
export type MaintenanceHubId = typeof MAINTENANCE_HUB_IDS[number];

export function normalizeMaintenancePathname(pathname: string): string {
  const path = (typeof pathname === 'string' ? pathname : '').trim().split(/[?#]/, 1)[0] || '/';
  const normalized = `/${path.replace(/^\/+|\/+$/g, '').replace(/\/{2,}/g, '/')}`;
  return normalized === '/' ? normalized : normalized.replace(/\/+$/, '');
}

function matchesRoot(pathname: string, root: string): boolean {
  return pathname === root || pathname.startsWith(`${root}/`);
}

export function resolveMaintenanceHub(pathname: string): MaintenanceHubId | null {
  const path = normalizeMaintenancePathname(pathname);

  if (path === '/' || path === '/login' || path === '/forbidden' || matchesRoot(path, '/admin')) return null;

  if ([
    '/business',
    '/unified-dashboard',
    '/personale',
    '/wallet',
  ].some((root) => matchesRoot(path, root))) return 'business';

  if ([
    '/dipendenze',
    '/piani-terapeutici',
    '/area-sanitaria',
    '/gestione-terapia',
    '/gestione-ordini',
    '/gestione-stdp',
    '/gestione-mmg',
    '/contatti-utili',
    '/gestione-assistiti',
    '/gestione-strutture',
  ].some((root) => matchesRoot(path, root))) return 'dipendenze';

  if (matchesRoot(path, '/documents') || matchesRoot(path, '/documenti')) return 'documenti';
  if (matchesRoot(path, '/applicativi')) return 'applicativi';
  if (matchesRoot(path, '/hr')) return 'hr';
  return null;
}
